module.exports = __webpack_public_path__ + "static/media/roti-menu.5b24cced.png";